import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.393 13.895a129.939 129.939 0 0 0-.403 10.162c-.002 3.375.129 6.724.39 10.048.13 1.647 1.13 2.895 2.321 2.895h2.547C34.215 37 35 35.909 35 34.562V13.439c0-1.347-.784-2.438-1.75-2.438h-2.535c-1.19 0-2.19 1.248-2.32 2.895Zm4.606-.11c0-.433-.168-.785-.376-.785h-1.63c-.384 0-.706.603-.748 1.4a185.12 185.12 0 0 0-.255 9.656c-.001 3.206.081 6.387.247 9.544.042.797.364 1.4.747 1.4h1.64c.207 0 .375-.352.375-.786V13.786ZM9.124 11.512l15.232 9.52a3.5 3.5 0 0 1-.002 5.938L9.102 36.489a3 3 0 0 1-4.57-2.212C4.175 31.073 3.998 27.67 4 24.063c.002-3.626.187-7.073.553-10.342a3 3 0 0 1 4.571-2.21Zm-1.479 1.55a1 1 0 0 0-1.105.883c-.357 3.193-.538 6.567-.54 10.12-.002 3.534.171 6.863.52 9.99a1 1 0 0 0 1.523.737l15.252-9.519a1.5 1.5 0 0 0 0-2.544l-15.23-9.52a1 1 0 0 0-.42-.147Zm35.951.833c.267 3.387.401 6.774.403 10.162.002 3.375-.129 6.724-.39 10.048-.13 1.647-1.13 2.895-2.321 2.895H38.74c-.967 0-1.751-1.091-1.751-2.438V13.439c0-1.347.784-2.438 1.75-2.438h2.535c1.19 0 2.19 1.248 2.32 2.895Zm-4.606-.11c0-.433.168-.785.376-.785h1.63c.384 0 .706.603.748 1.4.169 3.219.254 6.437.255 9.656.001 3.206-.081 6.387-.247 9.544-.042.797-.364 1.4-.747 1.4h-1.64c-.207 0-.375-.352-.375-.786V13.786Z",
    fill: "currentColor"
  }));
};

var SvgPlayPause = styled(SvgComponent).withConfig({
  displayName: "PlayPause__SvgPlayPause",
  componentId: "sc-1326pvi-0"
})(["", " ", ""], size, color);
export default SvgPlayPause;